import { FunctionalComponent } from 'preact'
import { GenericHeroConfig } from './index.sync'
// eslint-disable-next-line import/no-internal-modules
import ClientComponent from '@insided/deprecated-preact-components/client-component/index.server'
// eslint-disable-next-line import/no-internal-modules
import SearchForm from '@insided/deprecated-preact-components/algolia/components/SearchForm'
import { CurrentUserContext } from '@insided/shared/services/UserContext'
import classnames from 'classnames'

interface ContentStyles {
  container: string
  title: string
  subtitle: string
  search: string
}

const getContentStyles = (centered?: boolean): ContentStyles => {
  if (centered) {
    return {
      container: 'sitewidth',
      title: classnames('brand-hero-title', 'content--centered', 'qa-brand-hero-title'),
      subtitle: classnames('brand-hero-subtitle', 'content--centered', 'qa-brand-hero-subtitle'),
      search: 'hero-search'
    }
  }

  return {
    container: classnames('forum-list-view-spacing', 'forum-list-view-spacing--v', 'qa-subForum-header'),
    title: classnames('thread-list-view-title', 'brand-hero-title', 'qa-page-title'),
    subtitle: classnames('forum-list-view-description', 'brand-hero-subtitle', 'qa-subforum-description'),
    search: 'searchbar-in-hero'
  }
}

interface GenericHeroContentProps extends GenericHeroConfig, SearchScope {
  centered?: boolean
}

const GenericHeroContent: FunctionalComponent<GenericHeroContentProps> = ({
  centered,
  title,
  subtitle,
  isFederatedSkilljarSearch,
  isFederatedSalesforceSearch,
  isFederatedFreshdeskSearch
}) => {
  const styles = getContentStyles(centered)

  return (
    <CurrentUserContext.Consumer>
      {(user) => (
        <div className={styles.container}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <div className={styles.search}>
            {ClientComponent(SearchForm, 'algolia/components/SearchForm', {
              isUserGuest: !user.id,
              isFederatedSalesforceSearch: isFederatedSalesforceSearch,
              isFederatedSkilljarSearch: isFederatedSkilljarSearch,
              isFederatedFreshdeskSearch: isFederatedFreshdeskSearch
            })}
          </div>
        </div>
      )}
    </CurrentUserContext.Consumer>
  )
}

export default GenericHeroContent
